import React from 'react'
import { Grid, FormLabel, Typography, styled } from '@mui/material'
import PropTypes from 'prop-types'

const PREFIX = 'CheckField'

const classes = {
  root: `${PREFIX}-root`,
  label: `${PREFIX}-label`,
}

const styles = ({ theme }) => ({
  [`&.${classes.root}`]: {
    paddingBottom: theme.spacing(2),
  },
  [`& .${classes.label}`]: {
    fontSize: theme.spacing(1.5),
    color: '#505050',
    fontWeight: '600',
  },
})

const StyledGrid = styled(Grid)(styles)

function CheckField({ label, value, xs, sm, md, lg, xl }) {
  return (
    <StyledGrid
      item
      xs={xs}
      sm={sm}
      md={md}
      lg={lg}
      xl={xl}
      className={classes.root}
    >
      <FormLabel className={classes.label}>{label}</FormLabel>
      <Typography fontWeight="700">{value ? value : '-'}</Typography>
    </StyledGrid>
  )
}

CheckField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  xs: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  sm: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  md: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  lg: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  xl: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
}

export default CheckField
